import {useQuery} from '@tanstack/react-query';
import {getSupplier} from 'App/api/suppliers';
import {SUPPLIERS_QUERY_KEY} from 'App/data-hooks/queryKeys';

export const useGetSupplier = (supplierId: string) => {
  const {data, status, error} = useQuery([SUPPLIERS_QUERY_KEY, supplierId], () => getSupplier(supplierId));
  return {supplier: data, status, error};
};
